import React from 'react';
export function Footer() {
  return <footer className="bg-blue-950 text-blue-200/60 py-12 px-4 border-t border-blue-900" data-id="element-73">
      <div className="max-w-4xl mx-auto text-center" data-id="element-74">
        <h3 className="text-2xl font-bold text-white mb-4" data-id="element-75">
          🧠 MEGAPACK MENTE VIVA™
        </h3>
        <p className="text-blue-100 mb-8 max-w-md mx-auto" data-id="element-76">
          El sistema de estimulación cognitiva N°1 para adultos mayores en
          Argentina.
          <br data-id="element-77" />
          <span className="italic opacity-80 mt-2 block" data-id="element-78">
            Porque cuidar la mente de quien amás no debería ser tan difícil.
          </span>
        </p>

        <div className="flex flex-wrap justify-center gap-6 mb-12 text-sm font-medium text-blue-100/80" data-id="element-79">
          <a href="mailto:farixonsoporte@gmail.com" className="hover:text-amber-400 transition-colors flex items-center gap-2" data-id="element-80">
            📧 farixonsoporte@gmail.com
          </a>
          <span className="flex items-center gap-2" data-id="element-81">📲 @farixon</span>
          <a href="https://www.farixon.com" target="_blank" rel="noopener noreferrer" className="hover:text-amber-400 transition-colors flex items-center gap-2" data-id="element-82">
            🌐 www.farixon.com
          </a>
        </div>

        <div className="text-xs space-y-4" data-id="element-83">
          <p data-id="element-84">
            © Farixon™ 2026 — Todos los derechos reservados. Prohibida la
            reproducción y redistribución sin autorización expresa.
          </p>
          <p className="text-amber-500/50 font-serif italic text-sm" data-id="element-85">
            🧠 "La mente que se ejercita no envejece. Evoluciona."
          </p>
        </div>
      </div>
    </footer>;
}